<template>
  <el-container>
    <!-- 侧边栏导航 -->
    <el-aside width="250px" class="sidebar">
      <el-menu :default-active="activeMenu" @select="handleMenuSelect">
        <el-sub-menu index="1">
          <template #title>
            <el-icon><Location /></el-icon>
            <span>业主机构管理</span>
          </template>
          <el-menu-item index="1-1">机构信息管理</el-menu-item>
          <el-menu-item index="1-2">机构前端咨询管理</el-menu-item>
          <el-menu-item index="1-3">机构培训计划管理</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="2">
          <template #title>
            <el-icon><Document /></el-icon>
            <span>资料管理</span>
          </template>
          <el-menu-item index="2-1">试题库管理</el-menu-item>
          <el-menu-item index="2-2">视频文档管理</el-menu-item>
          <el-menu-item index="2-3">考试管理</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="3">
          <template #title>
            <el-icon><User /></el-icon>
            <span>学员管理</span>
          </template>
          <el-menu-item index="3-1">学员信息管理</el-menu-item>
          <el-menu-item index="3-2">学员学习情况</el-menu-item>
          <el-menu-item index="3-3">学员考试情况</el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="4">
          <template #title>
            <el-icon><Setting /></el-icon>
            <span>基础参数管理</span>
          </template>
          <el-menu-item index="4-1">机构类型管理</el-menu-item>
<!--          <el-menu-item index="4-2">培训周期管理</el-menu-item>-->
<!--          <el-menu-item index="4-3">培训类型管理</el-menu-item>-->
<!--          <el-menu-item index="4-4">文档视频类型管理</el-menu-item>-->
<!--          <el-menu-item index="4-5">前端展示列表管理</el-menu-item>-->
        </el-sub-menu>
        <el-sub-menu index="5">
          <template #title>
            <el-icon><Key /></el-icon>
            <span>用户权限管理</span>
          </template>
          <el-menu-item index="5-1">授权管理</el-menu-item>
<!--          <el-menu-item index="5-2">角色管理</el-menu-item>-->
          <el-menu-item index="5-3">用户管理</el-menu-item>
        </el-sub-menu>
      </el-menu>
    </el-aside>

    <!-- 右侧内容区域 -->
    <el-container>
      <el-header class="header">超级管理员系统</el-header>
      <el-main>
        <component
            v-if="isAuthorized"
            :is="currentComponent"

        />
        <div v-else>
          <p>校验失败，请重新登录。</p>
          <button @click="handleReLogin">重新登录</button>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>

import OrganizationManage from '@/components/Super/Organization/OrganizationInfor.vue'
import Showview from '@/components/Super/Organization/ShowView.vue'
import TrainingPlanManage from '@/components/Super/Organization/TPlan.vue'
import UserManage from '@/components/Super/Permision/MGUserView.vue'
import RoleManage from '@/components/Super/Permision/wos.vue'
import StudentInfoManage from '@/components/Super/XY/MGXYView.vue'
import StudentLearningManage from '@/components/Super/XY/MGXYLearn.vue'
import StudentExamManage from '@/components/Super/XY/MGTestView.vue'
import QuestionBankManage from '@/components/Super/Information/QuestionView.vue'
import VideoDocumentManage from '@/components/Super/Information/VideosAndImages.vue'
import FunctionManage from '@/components/Super/Permision/GNView.vue'
import OrganizationTypeManage from '@/components/Super/OrgType/OrgTypeView.vue'
import TrainingCycleManage from '@/components/Super/XY/EchartsView.vue'
import TrainingCycleManage1 from '@/components/Super/XY/EchartView1.vue'
import DocumentVideoTypeManage from '@/components/Super/XY/EchartView2.vue'
import SuperExamView from '@/components/Super/Information/SuperExamView.vue'
import { useUserStore } from '@/components/user';


export default {

  components: {
    OrganizationManage,
    SuperExamView,
    Showview,
    TrainingPlanManage,
    UserManage,
    RoleManage,
    StudentInfoManage,
    StudentLearningManage,
    StudentExamManage,
    QuestionBankManage,
    VideoDocumentManage,
    FunctionManage,
    OrganizationTypeManage,
    TrainingCycleManage,
    TrainingCycleManage1,
    DocumentVideoTypeManage,
  },
  data() {
    return {
      loginuserid:useUserStore().userId,
      isAuthorized: true,
      userid: this.$route.query.userid, // 获取路由中的用户id
      organizationID: this.$route.query.organizationID, // 获取路由中的机构id
      // userid: this.getQueryParam('userid'), // 从 URL 获取用户 ID
      // organizationID: this.getQueryParam('organizationID'), // 从 URL 获取机构 ID
      activeMenu: "1-1", // 默认选中的菜单
      componentMapping: {
        "1-1": "OrganizationManage",
        "1-2": "Showview",
        "1-3": "TrainingPlanManage",
        "2-1": "QuestionBankManage",
        "2-2": "VideoDocumentManage",
        "2-3": "SuperExamView",
        "3-1": "StudentInfoManage",
        "3-2": "StudentLearningManage",
        "3-3": "StudentExamManage",
        "4-1": "OrganizationTypeManage",
        "4-2": "TrainingCycleManage",
        "4-3": "TrainingCycleManage1",
        "4-4": "DocumentVideoTypeManage",
        // "4-5": "FrontendListManage",
        "5-1": "FunctionManage",
        "5-2": "RoleManage",
        "5-3": "UserManage",
      },
    };
  },
  created() {
    console.log('路径的用户id'+this.userid)
    console.log(this.organizationID)
    // this.validatePageAccess()
  },
  computed: {
    currentComponent() {
      return this.componentMapping[this.activeMenu] || null;
    },
  },
  methods: {
    handleMenuSelect(index) {
      this.activeMenu = index;
    },
    // 校验逻辑
    validatePageAccess() {
      const storedUserInfo = JSON.parse(localStorage.getItem('userInfo'+this.loginuserid));

      if (storedUserInfo) {
        const { userID, organizationID } = storedUserInfo;

        // 校验本地存储的值与 URL 中的值是否一致
        if (
            parseInt(userID) === parseInt(this.userid) &&
            parseInt(organizationID) === parseInt(this.organizationID)
        ) {
          this.isAuthorized = true; // 校验通过
        } else {
          this.isAuthorized = false; // 校验失败
        }
      } else {
        this.isAuthorized = false; // 如果未登录，校验失败
      }
    },

    // 处理重新登录
    handleReLogin() {
      // 清除本地信息，跳转到登录页面
      localStorage.removeItem('userInfo'+this.loginuserid);

      window.location.href = '/MGLogin'; // 假设有登录页
    },
  },
};
</script>

<style scoped>
.sidebar {
  background-color: #f4f4f4;
  height: 100vh;
}

.header {
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  line-height: 50px;
  font-size: 18px;
}
</style>
